const getBrand = () => {
  if (window && window.location) {
    const hostname = window.location.hostname
    if (hostname.indexOf('toyota') !== -1) {
      return 'toyota'
    }
    if (hostname.indexOf('lexus') !== -1) {
      return 'lexus'
    }
    if (hostname.indexOf('suzuki') !== -1) {
      return 'suzuki'
    }
    return 'toyota'
  }
}
export default getBrand
